import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Alert, Collapse, Modal } from 'react-bootstrap';
import { Form, Input, Checkbox } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

import { Black, Center, ImageSection, NoBorderInput, LogeButton, ModalHeading } from './GeneralStyle'

import DataPrivDisclaimer from './DataPrivDisclaimer'
import headerImage from '../images/modal/tl_header_login.jpg';

@inject('userStore')

@observer
class LoginModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAlert: false,
      showModal: this.props.showModal
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  closeModal = (data) => {
    this.setState({ showModal: false });
  }

  openModal = (data) => {
    this.setState({ showModal: true });
  }

  onSubmit = (data) => {
    const userStore = this.props.userStore;
    const cookies = this.props.cookies;
    let username = data.username.toLowerCase()

    // log in and check set cookies
    userStore.login(username, data.password).then(res => {
      if (res === false) {
        this.setState({
          showAlert: true
        })
      } else {
        cookies.set('sessionToken', res.sessionToken, { path: '/', maxAge: 60 * 60 * 24 * 365 });
        cookies.set('sessionToken', res.sessionToken, { path: '/internal', maxAge: 60 * 60 * 24 * 365 });

        this.props.history.push("/internal")
        this.closeModal()
      }
    })
  }

  handleAlertDismiss() {
    this.setState({
      showAlert: false
    })
  }

  render() {
    const isDefaultRequiredValue = 'Das ist ein Pflichtfeld.'

    return (
      <Modal show={this.state.showModal} onHide={this.closeModal}>
        <ImageSection background={headerImage}>
          <Modal.Header closeButton>
            <Modal.Title>
              <div>
                <ModalHeading>
                  THE LOGE Member Login
                </ModalHeading>
              </div>
            </Modal.Title>
          </Modal.Header>
        </ImageSection>
        <Modal.Body>
          <Collapse in={this.state.showAlert}>
            <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
              <h4>Kein gültiger Login</h4>
              <p>Sie haben entweder ein falsches Passwort oder einen falschen Benutzernamen eingegeben!</p>
            </Alert>
          </Collapse>

          <Form
            onSubmit={this.onSubmit}
            layout={'vertical'}
            validateOnSubmit={false}
            validatePristine={false}
            formNoValidate
            noValidate
          >
            <NoBorderInput>
              <Input
                name="username"
                value=""
                type="text"
                placeholder="E-Mail Adresse"
                validationErrors={{ isDefaultRequiredValue }}
                required
              />
            </NoBorderInput>
            <Input
              name="password"
              value=""
              type="password"
              validationErrors={{ isDefaultRequiredValue }}
              placeholder="Passwort"
              required
            />
            <DataPrivDisclaimer />
            <Center marginTop={30} marginBottom={30}>
              <LogeButton
                hoverFontColor={"white"}
                type="submit">Login</LogeButton>
            </Center>

          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

LoginModal.propTypes = {
  userStore: MobxPropTypes.observableObject,
  cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(LoginModal));



// WEBPACK FOOTER //
// /src/components/LoginModal.js